export const Backdrop = theme => {
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          background: "#e6f4ff66",
          "&.MuiBackdrop-invisible": {
            background: "transparent",
          },
        },
      },
    },
  }
}
